import styled from "@emotion/styled";
import { Tooltip } from "@mui/material";
import { Component } from "react";
import { Utils } from "../common/Utils";
import { INTEGRATION_STATUS } from "../constants";
import WarningIcon from "../resources/images/icon-warning-no-color.svg";
import CheckCircleIcon from "../resources/images/icons-check-circle.svg";
import PauseIcon from "../resources/images/icons-pause-circle.svg";
import { KLAYO_COLORS } from "../themes";

interface CompanyIntegrationStatusProps {
  status?: (typeof INTEGRATION_STATUS)[keyof typeof INTEGRATION_STATUS];
  lastSyncDate?: string;
  isLiveSync?: boolean;
  translate?: (key: string, options?: Record<string, unknown>) => string;
}

export class CompanyIntegrationStatus extends Component<CompanyIntegrationStatusProps> {
  constructor(props: CompanyIntegrationStatusProps) {
    super(props);
  }

  render() {
    const { status, lastSyncDate, isLiveSync, translate } = this.props;
    const workingStatusToolTipMessage = isLiveSync
      ? "Live"
      : lastSyncDate
        ? `Last Sync (UTC): ${Utils.formatDate(lastSyncDate, "long")} `
        : "Not synced yet";

    return (
      <StyledCompanyIntegrationStatus className='klayo_company-integration-status'>
        {status === INTEGRATION_STATUS.ACTIVE ? (
          <>
            <Tooltip
              classes={{ tooltip: "klayo__integration-status-tooltip" }}
              title={<div>{workingStatusToolTipMessage}</div>}
              placement='left'
              arrow
            >
              <CheckCircleIcon />
            </Tooltip>
            <p className='status'>{translate?.("status.working") ?? "Working"}</p>
          </>
        ) : status === INTEGRATION_STATUS.PAUSE ? (
          <>
            <Tooltip
              classes={{ tooltip: "klayo__integration-status-tooltip" }}
              title={
                <div>
                  {translate?.("tooltips.integrationPaused") ??
                    "Integration has been paused by the Klayo team"}
                </div>
              }
              placement='left'
              arrow
            >
              <PauseIcon className='pause-icon' />
            </Tooltip>
            <p className='status'>{translate?.("status.paused") ?? "Paused"}</p>
          </>
        ) : status === INTEGRATION_STATUS.ISSUE ? (
          <>
            <Tooltip
              classes={{ tooltip: "klayo__integration-status-tooltip" }}
              title={
                <div>
                  {translate?.("tooltips.integrationError") ??
                    "An error was encountered on the last synchronization"}
                </div>
              }
              placement='left'
              arrow
            >
              <WarningIcon className='warning-icon' />
            </Tooltip>
            <p className='status'>{translate?.("status.notWorking") ?? "Not Working"}</p>
          </>
        ) : (
          <></>
        )}
      </StyledCompanyIntegrationStatus>
    );
  }
}

const StyledCompanyIntegrationStatus = styled.div`
  &.klayo_company-integration-status {
    display: flex;
    align-items: center;
    gap: 12px;

    .status {
      margin: 0px;
      color: ${KLAYO_COLORS.GreyGR900};
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.1px;
    }

    .warning-icon {
      color: ${KLAYO_COLORS.TouchRedTR600};
    }

    .pause-icon {
      color: ${KLAYO_COLORS.GreyGR400};
    }

    @media (max-width: 600px) {
      .status {
        display: none;
      }
    }
  }
`;
